export default {
  retail: {
    breadcrumbHome: 'Accueil',
    breadcrumbSolutions: 'Solutions',
    breadcrumbCurrent: 'Commerce et restauration',
    hero: {
      eyebrow: 'Commerce et restauration',
      title: 'Plus de sécurité dans les commerces et la restauration',
      lead: 'Entrée, caisse, réserve et accès cuisine : nous protégeons votre activité contre le vol et le vandalisme sans déranger vos clients.',
    },
    points: {
      title: 'Points de surveillance pour commerce et restauration',
      lead: 'Chaque commerce et établissement a ses propres zones à risque. Nous plaçons les caméras exactement là où elles font la différence.',
      items: {
        '0': { title: 'Entrée et vitrine', desc: 'Le premier point de surveillance : les caméras d’entrée documentent les allées et venues et dissuadent dès l’entrée.' },
        '1': { title: 'Zone de caisse', desc: 'La caisse et la zone de paiement sont le point le plus sensible du commerce. Des caméras discrètes sécurisent sans inquiéter.' },
        '2': { title: 'Surface de vente', desc: 'Vue d’ensemble : les caméras grand-angle détectent les mouvements suspects dans les rayons et allées.' },
        '3': { title: 'Réserve et livraisons', desc: 'Réception des marchandises, réserve et accès du personnel : des brèches apparaissent ici. Nous les comblons.' },
        '4': { title: 'Comptoir et accès cuisine', desc: 'En restauration, le comptoir et l’accès cuisine sont des zones critiques. Des caméras robustes résistent à l’humidité et à la chaleur.' },
        '5': { title: 'Terrasse extérieure', desc: 'La terrasse et les tables extérieures attirent les opportunistes, surtout le soir. Des caméras résistantes veillent.' },
      },
    },
    protection: {
      eyebrow: 'Protection contre le vol',
      title: 'Moins de démarque, plus de sécurité',
      lead: 'Le vol à l’étalage et les écarts d’inventaire coûtent cher chaque année. Des caméras bien placées réduisent les pertes et fournissent des images utiles.',
      items: {
        '0': { title: 'Surveillance de la caisse', desc: 'Images nettes de la caisse et de la zone de paiement, pour une documentation complète en cas de litige.' },
        '1': { title: 'Vitrines et accès', desc: 'Dissuasion et clarification en cas de vandalisme ou d’effraction, de la vitrine à l’entrée arrière.' },
        '2': { title: 'Journaux d’événements', desc: 'Mouvement, franchissement de ligne ou événements de porte déclenchent enregistrement et notifications push.' },
      },
    },
    gastro: {
      eyebrow: 'Restauration',
      title: 'Technologie robuste pour comptoir, cuisine et terrasse',
      lead: 'Vapeur, graisse et humidité exigent beaucoup de la technologie. Nous choisissons des caméras fiables au quotidien, que les clients ne remarquent pas.',
      list: {
        '0': 'Surveiller l’accès cuisine : personnel autorisé uniquement',
        '1': 'Sécuriser comptoir et caisse sans déranger les clients',
        '2': 'Garder terrasse et extérieur à l’œil en soirée',
        '3': 'Documenter fournisseurs et livraisons sans lacune',
        '4': 'Poser une signalétique pour clients et personnel',
      },
      note: 'Remarque : la licéité de la vidéosurveillance dépend du cas. Nous vous conseillons, sans remplacer le conseil juridique.',
    },
    cta: {
      title: 'Votre activité mérite un cadre sécurisé',
      lead: 'Nous vous montrons sans engagement où la vidéosurveillance est rentable et où elle n’est pas nécessaire.',
      primary: 'Prendre rendez-vous',
      secondary: 'Découvrir SSG Care',
    },
  },
};